module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic05.a99643e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic05.png
// module id = 523
// module chunks = 1